// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-dialog[data-v-4024a604] {\r\n  max-width: 600px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
